<template>
  <v-layout column >
      <v-flex class="flexBasis" md6 style="overflow: none">
        <v-data-table
        :headers='headers'
        :items='adoptions'
        hide-default-footer
        :disable-pagination="true"
        >
          <template v-slot:top>
            <v-select
              class="mt-4 ml-1"
              style="width:25%"
              @change="switchAdoptionType"
              v-model='defaultDDSelected'
              :items="['Current', 'Past']"
              dense
              solo
            ></v-select>
          </template>
          <template v-slot:item.bookTitleYear="{ item }">
            <span v-if="typeof item.customBookTitleYear !== 'undefined' && item.customBookTitleYear !== ''">{{ item.customBookTitleYear }}</span>
            <span v-else >{{ item.bookTitleYear }}</span>
          </template>
          <template v-slot:no-data>
            <p>{{NO_DATA_FOUND}}</p>
          </template>
        </v-data-table>
  </v-flex>
</v-layout>
</template>

<script>
import CONSTANTS from './../../../../config/constant'

export default {
  data: () => ({
    defaultDDSelected: 'Current',
    TABLE_TITLE: 'Adoptions',
    ADD_NEW_ADOPTION: 'MANAGE ADOPTION(S)',
    NO_DATA_FOUND: CONSTANTS.NO_DATA_FOUND,
    compAdoptionList: [],
    initialAdoptionList: [],
    editDialog: false,
    headers: [
      {
        text: 'Book Title',
        value: 'bookTitleYear',
        sortable: false,
        class: 'subtitle-2'
      },
      {
        text: 'Effective Date',
        value: 'effectiveDate',
        sortable: false,
        class: 'subtitle-2'
      },
      {
        text: 'Adoption Type',
        value: 'adoptionType',
        sortable: false,
        class: 'subtitle-2'
      },
      {
        text: 'Adoption Label',
        value: 'adoptionLabel',
        sortable: false,
        class: 'subtitle-2'
      }
    ],
    defaultItem: {
      codeBookId: '',
      date: '',
      adoptionStatus: ''
    }
  }),
  props: {
    adoptionLevelFor: {
      Type: String
    },
    adoptionLevel: {
      Type: Number
    },
    name: {
      Type: String
    }
  },
  mounted () {
    let adoptionLevel = this.adoptionLevel
    let adoptionLevelFor = this.adoptionLvlFor
    let adoptionName = this.adoptionName
    this.$store.commit('AdoptionModule/setAdoptionData', { adoptionLevel, adoptionLevelFor, adoptionName })
    this.initialize()
  },
  computed: {
    // to get logged in user ID
    userId () {
      return this.$store.getters['AuthModule/getUserId']
    },
    // to fetch adoption list
    adoptions () {
      return this.compAdoptionList
    },
    adoptionLvlFor () {
      return this.adoptionLevelFor
    },
    id () {
      return this.adoptionLevel
    },
    adoptionName () {
      return this.name
    }
  },
  methods: {
    // dispatch an action in below method to fetch adoption list
    initialize () {
      new Promise((resolve, reject) => {
        this.$store.dispatch('AdoptionModule/getMappedAdoptionList', {
          resolve,
          reject
        })
      })
        .then(responseData => {
          this.initialAdoptionList = this.$store.getters['AdoptionModule/fetchMappedAdoptionList']
          this.switchAdoptionType('current')
          // emit activity log data to parent
          if (responseData.auditList.length > 0) {
            this.$emit('activityLogItems', responseData.auditList)
          } else {
            this.$emit('activityLogItems', '')
          }
          this.$emit('auditLogLoader', false)
        })
        .catch(response => {
          this.compAdoptionList = []
          this.initialAdoptionList = []
          this.$emit('auditLogLoader', false)
        })
    },
    removeDialog () {
      this.$store.commit('JurisdictionModule/setEditDialog', false)
    },
    switchAdoptionType (adopType) {
      let resultSet = []
      let listCurrentOnly = []
      resultSet = this.initialAdoptionList
      if (adopType.toLowerCase() === 'current') {
        listCurrentOnly = resultSet.filter(function (item) {
          return item.adoptionStatus === 'Current Adoption'
        })
        this.compAdoptionList = listCurrentOnly
      } else if (adopType.toLowerCase() === 'past') {
        listCurrentOnly = resultSet.filter(function (item) {
          return item.adoptionStatus === 'Past Adoption'
        })
        this.compAdoptionList = listCurrentOnly
      }
    },
    bulkEditUrl (id, adoptionLevel) {
      this.$router.push({ name: 'BulkAdoption', params: { adoptionLevel: CONSTANTS.BULK_ADOPTION_URL[adoptionLevel], id: id } })
    }
  }
}
</script>
